module.exports = __webpack_public_path__ + "img/twitter.fe8f1238.png";